import { TypographyT5, TypographyT6 } from '@picsart/design-system/foundation/typography';

import cls from 'classnames';

import { Text, TextElementTypes } from '@picsart/design-system/components/Text';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

import TitleWithDescription from 'components/Colors/TitleWithDescription';
import CenteredContainer from 'components/Colors/CenteredContainer';
import usePageDataStore from 'stores/pageDataStore';

import Image from 'components/Image';
import { ColorWithTextProps } from './types';
import useStyles from './styles';

function ColorWithText({ className, data, colorImageAlt }: ColorWithTextProps) {
  const { name } = usePageDataStore(store => store.pageData?.data);
  const { hex } = usePageDataStore(store => store.colorData);
  const classes = useStyles({ color: hex });

  return (
    <CenteredContainer>
      <div className={cls(classes.root, className)}>
        <div className={classes.colorContainer}>
          <div className={cls('flex-centered', classes.background)}>
            <div className={classes.nameContainer}>
              <div className={classes.color} />
              <div className={classes.name}>
                <Text
                  className={classes.title}
                  elementType={TextElementTypes.Span}
                  size={TypographyT6}
                  weight={FontWeights.medium}
                >
                  {name}
                </Text>
                <Text
                  elementType={TextElementTypes.Span}
                  size={TypographyT5}
                  className={classes.hex}
                >
                  {hex}
                </Text>
              </div>
            </div>
            <Image
              className={classes.logo}
              src="https://pastatic.picsart.com/cms-pastatic/7c8adf15-a95b-4469-9682-abf44edb99bb.svg"
              alt={colorImageAlt || 'Picsart Logo'}
            />
          </div>
        </div>
        <div className={cls(classes.textContainer, 'flex-centered')}>
          <TitleWithDescription title={data.title} description={data.description} />
        </div>
      </div>
    </CenteredContainer>
  );
}

export default ColorWithText;
